import { render, staticRenderFns } from "./WelcomeDialog.vue?vue&type=template&id=3410d378&scoped=true&"
import script from "./WelcomeDialog.vue?vue&type=script&lang=js&"
export * from "./WelcomeDialog.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeDialog.vue?vue&type=style&index=0&id=3410d378&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3410d378",
  null
  
)

export default component.exports